jQuery(document).ready(function($){

  // language selector
  $('select.lang-selector').find('option').each(function(){
    if( $(this).val() == window.default_locale){
      $(this).attr('selected', 'selected');
    }
  });

  $('select.lang-selector').selectize();

  $(document).on('change', 'select.lang-selector', function(){

    let option = $(this).find('option:selected').val();

    $.ajax({

      method: 'post',
      url: window.location.origin + '/lang',
      headers: {
        'X-CSRF-TOKEN': $(document).find('input[name="global_token"]').val()
      },
      data: {
        lang: option
      },
      dataType: 'json',
      beforeSend: function(){
        $('body').addClass('loading');
      },
      error: function(xhr){
        console.log(xhr);
        $('body').removeClass('loading');
      },
      success: function(data){
        window.location.reload();
      } // ajax.success

    }) // ajax.call

  }); // on.change()

  // validate login form
  $('#login-form').validate({

    rules: {
      username: 'required',
      password: 'required',
      // 'g-recaptcha-prev-response': 'required'
    },

    messages: {
      username: {
        required: window.trans.get('messages.login.validation.username')
      },
      password: {
        required: window.trans.get('messages.login.validation.password')
      },
      /*'g-recaptcha-prev-response': {
        required: window.trans.get('messages.login.validation.recaptcha')
      }*/
    },

    errorPlacement: function(error, element){

      if( element.parent('div.password-input').length ){

        error.insertAfter( element.parent('div.password-input') );

      } else{
        error.insertAfter(element);
      }

    },

    onfocusout: function(element) {
      this.element(element);
    },

    submitHandler: function(){
      login_process_data();
    }

  })

  // process form data
  function login_process_data(){

    var form = $('#login-form');
    var button = $('#login-form').find('button[type="submit"]');
    var token = form.find('input[name="_token"]').val();
    var remember_me = ( form.find('input[name="remember_me"]').is(':checked') ? true : false );
    var previous_url = ( form.find('input[name="previous_url"]').val() ? form.find('input[name="previous_url"]').val() : null )

    console.log(previous_url);

    $.ajax({

      method: 'post',
      url: '/login',
      headers: {
        'X-CSRF-TOKEN': token
      },
      data: {
        username: form.find('input[name="username"]').val(),
        password: form.find('input[name="password"]').val(),
        previous_url: previous_url,
        remember_me: remember_me,
        recaptcha_token: $('#g-recaptcha-prev-response').val()
      },
      dataType: 'json',
      beforeSend: function(){
        button.addClass('loading');
      },
      error: function(xhr){

        if( xhr.status == 422 ){
          form.bonin_form_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.credentials')
          });
        }
        if( xhr.status == 401 ){
          form.bonin_form_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.credentials')
          });
        }
        if( xhr.status == 403 ){
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.not_allowed')
          })
        }
        if( xhr.status == 405 ){
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.login.validation.recaptcha')
          })
        }
        if( xhr.status == 406 ){
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.recaptcha')
          })
        }
        if( xhr.status == 429 ){
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.max_rate')
          })
          
        }
        if( xhr.status == 500 ){
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.login.errors.internal_error')
          })
        }
        onResetRecaptcha()
        button.removeClass('loading');

      },
      success: function(data){

        // Vwerifica del parametro ref_url
        let ref_url = new URLSearchParams(window.location.search).get('ref_url');

        if (ref_url && ref_url != '') {

          window.location.replace( ref_url );

        } else {

          if( data.url ){
            window.location.replace( data.url );
          }

        }



      } // ajax.success

    }) // ajax.call

  } // end of function

}) // end of document.ready
